import { AgentSessionManager } from '@Components/AgentChat';
import { EmptyState } from '@Components/EmptyState';
import { Page } from '@Components/Page';
import { PAGE_NAMES } from '@Components/Page/page-constants';
import { Agent, useAgentEndpoint } from '@src/utils/agent-endpoints';

export const CrossClientOracleChat = () => {
  const agentEndpoint = useAgentEndpoint(Agent.ORACLE);

  return (
    <Page
      title={PAGE_NAMES.CROSS_CLIENT_ORACLE_CHAT}
      pageType={PAGE_NAMES.CROSS_CLIENT_ORACLE_CHAT}
    >
      <AgentSessionManager
        agent={Agent.ORACLE}
        agentEndpoint={agentEndpoint}
        placeholder='Ask Oracle about any client...'
        emptyState={
          <EmptyState
            title='Ask Oracle about any client'
            subtitle='Answers can cover all clients. Type a question below to start.'
          />
        }
        disableFeedback
        startFresh
      />
    </Page>
  );
};
